import React from 'react';
import { useObserver } from 'mobx-react-lite';
import styled from 'styled-components/macro';
import { useMst } from '../models/WithWineState';
import StoreFilterOptions from './StoreFilterOptions';
import { StoreFilterProps } from '../types/StoreFilterProps';
import { useStoreFilterDefaults } from '../utils/hooks/useStoreFilterDefaults';
import { sortByFn } from '../utils/sortByProperty';

const UnstyledStoreFilter: React.FC<StoreFilterProps> = ({
  className,
  defaultfilter,
  sort,
}) => {
  const state = useMst();
  const notWineType = ['Spirits', 'Cider', 'Beer'];
  const WineTypeLabel = state.widgets.storeFilter.filteredWineType.some(
    (x) => x.productGroup && notWineType.includes(x.productGroup),
  )
    ? 'Type'
    : 'Wine Type';
  useStoreFilterDefaults(defaultfilter, sort);

  return useObserver(() => (
    <div className={'ww-widget ww-store-filter ' + className}>
      <StoreFilterOptions
        options={state.widgets.storeFilter.filteredList.sort(
          sortByFn((f) => f.sortIndex),
        )}
        circular
      >
        List
      </StoreFilterOptions>

      <StoreFilterOptions
        options={state.widgets.storeFilter.filteredWineType.sort(
          sortByFn((f) => f.sortIndex),
        )}
      >
        {WineTypeLabel}
      </StoreFilterOptions>

      <StoreFilterOptions
        options={state.widgets.storeFilter.filteredVariety.sort(
          sortByFn((f) => f.sortIndex),
        )}
      >
        Variety
      </StoreFilterOptions>

      <StoreFilterOptions
        options={state.widgets.storeFilter.filteredRegion.sort(
          sortByFn((f) => f.sortIndex),
        )}
        visibleIf={(opts) =>
          opts.filter(
            (opt) =>
              opt.idValue !== null &&
              (opt.idValue + '').toLowerCase() !== 'multiple',
          ).length > 1
        }
      >
        Region
      </StoreFilterOptions>

      <StoreFilterOptions
        options={state.widgets.storeFilter.filteredAvailability.sort(
          sortByFn((f) => f.sortIndex),
        )}
        circular
      >
        Availability
      </StoreFilterOptions>
    </div>
  ));
};

const StoreFilter = styled(UnstyledStoreFilter)`
  color: var(--gray-5);
  display: flex;
  flex-direction: column;
  min-width: 20.192em;
`;

export default StoreFilter;
